import formatDate from "constants/formatDate";
import formatPhone from "constants/formatPhone";
import { licencePlateCheck } from "helpers/fakebackend_helper";
import React, { useState } from "react";
import { Container, Row, Col, Button, Input, Spinner, Alert, Badge, Card, CardBody } from "reactstrap";

const LicencePlateCheck = () => {
    document.title = "License Plate Check | CurbDash";

    const backgroundStyle = {
        minHeight: "100vh",
        background: "linear-gradient(135deg, #ffffff, #f0f0f0)", // same as SunsetBlvd3600
    };

    const buttonStyle = {
        padding: "1rem",
        fontSize: "1.1rem",
        fontWeight: 600,
        background: "linear-gradient(135deg, #1e1e1e, #4a4a4a)", // same as SunsetBlvd3600
        border: "none",
    };

    const [plate, setPlate] = useState("");
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    const handleCheck = async () => {
        if (!plate.trim()) return;
        setLoading(true);
        setResult(null);
        try {
            const res = await licencePlateCheck({ licence_plate: plate });
            setResult(res);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="d-flex align-items-center justify-content-center" style={backgroundStyle}>
            <Container>
                <Row className="justify-content-center text-center">
                    <Col md={6}>
                        <img
                            src="/cs-logo-circle.png"
                            alt="Curbstand Logo"
                            style={{ width: "60%", maxWidth: 280, marginBottom: 30 }}
                        />
                        <h2 className="text-dark mb-5 fw-semibold" style={{ fontSize: "2rem" }}>
                            License Plate Check
                        </h2>

                        <Input
                            type="text"
                            placeholder="Enter License Plate"
                            value={plate}
                            onChange={(e) => setPlate(e.target.value)}
                            style={{
                                textAlign: "center",
                                padding: "0.9rem",
                                fontSize: 18,
                                marginBottom: 25,
                            }}
                        />

                        <Button onClick={handleCheck} disabled={loading} style={buttonStyle}>
                            {loading ? <Spinner size="sm" /> : "Check"}
                        </Button>

                        {/* Results */}
                        {result && (
                            <div className="mt-4 text-start">
                                {result.matches_count === 0 && (
                                    <Alert color="danger" className="text-center fw-semibold">
                                        Licence Plate Not Found
                                    </Alert>
                                )}

                                {result.matches_count > 0 &&
                                    [...result.matches]
                                        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                                        .map((m, i) => (
                                            <Card key={i} className="mb-3 shadow-sm border-0">
                                                <CardBody>
                                                    <Row className="align-items-center text-center text-md-start">
                                                        {/* Left: Customer Info */}
                                                        <Col xs="12" md="5" className="mb-3 mb-md-0">
                                                            <h6 className="mb-1 text-dark">{m.full_name || "Unknown"}</h6>
                                                            <p className="mb-0 text-muted" style={{ fontSize: 13 }}>
                                                                {formatPhone(m.phone_number) || "N/A"}
                                                                <br />
                                                                {m.email || "N/A"}
                                                            </p>
                                                        </Col>

                                                        {/* Middle: Price Circle */}
                                                        <Col
                                                            xs="12"
                                                            md="2"
                                                            className="d-flex justify-content-center align-items-center mb-3 mb-md-0"
                                                        >
                                                            <div
                                                                style={{
                                                                    width: 70,
                                                                    height: 70,
                                                                    borderRadius: "50%",
                                                                    background: "#ccf4d1",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    fontWeight: 500,
                                                                    fontSize: 18,
                                                                    color: "#2e7d32",
                                                                    boxShadow: "0 0 8px rgba(0,0,0,0.1)",
                                                                }}
                                                            >
                                                                ${m.price}
                                                            </div>
                                                        </Col>

                                                        {/* Right: Payment Status & Receipt */}
                                                        <Col xs="12" md="5" className="text-md-end">
                                                            <Badge
                                                                color={m.status === "paid" ? "success" : "danger"}
                                                                pill
                                                                className="mb-1"
                                                            >
                                                                {m.status === "paid" ? "Payment Succeeded" : "Payment Failed"}
                                                            </Badge>
                                                            <p className="mb-1 text-muted" style={{ fontSize: 12 }}>
                                                                {formatDate(m.created_at)}
                                                            </p>
                                                            <Button
                                                                color="primary"
                                                                size="sm"
                                                                href={m.invoice_url}
                                                                target="_blank"
                                                            >
                                                                Receipt
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        ))}
                            </div>
                        )}

                        <div className="d-flex flex-wrap align-items-center justify-content-center mt-5 mb-5">
                            <p
                                className="text-muted mb-2 mb-sm-0"
                                style={{ fontSize: 18, marginRight: 8, textAlign: "center", width: "100%", maxWidth: "auto" }}
                            >
                                Powered by
                            </p>
                            <a
                                href="https://www.curbstand.com/"
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    width: "100%",
                                }}
                            >
                                <img
                                    src="/cs_horizontal_logo.webp"
                                    alt="Curbstand"
                                    style={{
                                        height: "auto",
                                        width: "70%",
                                        maxWidth: 220,
                                        minWidth: 150,
                                    }}
                                />
                            </a>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default LicencePlateCheck;